

































import { Component, Vue } from 'vue-property-decorator'
import {store, WorkItem} from '@/app/store'
import WorkCollection from '../components/organisms/work-collection.vue'
import HappinessCollection from '../components/organisms/work-happiness.vue'
import {MouseScroll} from '@/app/lib/mouse-scroll'
@Component({
  components:{
    'work-collection':WorkCollection,
    'work-happiness':HappinessCollection,
  },
})
export default class WorksItem extends Vue {
  id:string = ''
  title:string = 'タイトル'
  scroll:MouseScroll = new MouseScroll()
  get item(){
    return store.getWork(this.id) || store.emptyWork
  }
  clickBack(){
    this.$router.push('/works')
  }
  mounted(){
    console.log(this.$route)
    this.id = this.$route.params.id
    this.scroll.init(this.$refs.imageList as HTMLElement)
  }
  beforeDestroy(){
    this.scroll.dispose()
  }
}
